import Lenis from 'lenis'
import { useEffect, useRef } from 'react'

let lenisInstance: Lenis | null = null

export function useLenis(): Lenis | null {
  const lenisRef = useRef<Lenis | null>(null)

  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.1,
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1,
    })

    lenisRef.current = lenis
    lenisInstance = lenis

    let rafId: number

    function raf(time: number) {
      lenis.raf(time)
      rafId = requestAnimationFrame(raf)
    }

    rafId = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(rafId)
      lenis.destroy()
      lenisRef.current = null
      lenisInstance = null
    }
  }, [])

  return lenisRef.current
}

export function getLenis(): Lenis | null {
  return lenisInstance
}
